import {Link} from '@primer/react'

import styles from './FeedbackLink.module.css'

export interface OptionalFeedbackLinkProps {
  /**
   * Optional feedback URL. Should always be included if the lifecycle label is not part of a navigation item. This
   * should typically be a link to a GitHub Discussion - ensure that all users with access to the feature also have
   * access to this discussion.
   */
  feedbackUrl?: string
  /**
   * If true, the feedback link opens in a new tab.
   */
  opensInNewTab?: boolean
}

interface RequiredFeedbackLinkProps extends OptionalFeedbackLinkProps {
  feedbackUrl: string
}

/** "Give feedback" link. Renders nothing if no URL is passed. */
export const FeedbackLink = ({feedbackUrl, opensInNewTab}: RequiredFeedbackLinkProps) => (
  <Link
    className={styles.link}
    href={feedbackUrl}
    inline
    target={opensInNewTab ? '_blank' : undefined}
    rel={opensInNewTab ? 'noopener noreferrer' : undefined}
  >
    Give feedback
  </Link>
)
